import MarcaService from "@/services/MarcaService"
import {router} from "@/router"

export const actions = {
    cadastrarMarca: ({commit, dispatch}) => {
        commit('setMarca', {
            marca: ''
        })

        dispatch('setModalCadastroMarca', true)
        
    },
    listarMarcas: ({commit}) => {
        commit('setOverlay', true)
        MarcaService.listar()
        .then(res => {
            commit('setMarcas', res.data)
            commit('setOverlay', false)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
        })
    },
    visualizarMarca: ({commit}, id) => {
        commit('setOverlay', true)
        MarcaService.editar(id)
        .then(res => {
            commit('setMarca', res.data)
            commit('setOverlay', false)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
        })
    },
    salvarMarca: ({commit, dispatch}, data) => {
        dispatch('setModalCadastroMarca', false)
        commit('setOverlay', true)
        MarcaService.salvar(data)
        .then(res => {
            dispatch('listarMarcas')
            commit('setOverlay',false)  
            commit('snackbarSuccess', 'Marca cadastrada.') 
        })
        .catch(e => {
            console.log(e)
            commit('snackbarError', 'Erro ao cadastrar marca.') 
        })
    },
    atualizarMarca: ({commit, dispatch}, data) => {
        dispatch('setModalCadastroMarca', false)
        commit('setOverlay', true)
        MarcaService.atualizar(data)
        .then(res => {
            dispatch('listarMarcas')
            commit('setOverlay',false)  
            commit('snackbarInfo', 'Marca atualizada.') 
        })
        .catch(e => {
            console.log(e)
            commit('snackbarError', 'Erro ao atualizar marca.') 
        })
    },
    excluirMarca: ({commit, dispatch}, id) => {
        dispatch('setModalCadastroMarca', false)
        commit('setOverlay', false)
        MarcaService.excluir(id)
        .then(res => {
            dispatch('listarMarcas')
            commit('setOverlay',false)  
            commit('snackbarError', 'Marca excluída.') 
        })
        .catch(e => {
            console.log(e)
            commit('snackbarError', 'Erro ao excluir marca.') 
        })
    },
    setModalCadastroMarca: ({commit}, status) => {
        commit('setModalCadastroMarca', false)
        setTimeout(() => {
            commit('setModalCadastroMarca', status)
        }, 100);
    },
    setModalExcluirMarca: ({commit}, status) => {
        commit('setModalExcluirMarca', false)
        setTimeout(() => {
            commit('setModalExcluirMarca', status)
        }, 100);
    },
    
}

export default {}